import * as React from 'react';
import * as style from './style.css';

export const MarkedList = ({ children }: React.PropsWithChildren) => {
  return <ul className={style['seo-ul']}>{children}</ul>;
};
